import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface NewTagModalFormProps {
  PageUrlCategoryValidationSchema: any;
  onCreateNewPageUrlCategory: (userDetails: any) => void;
  pageUrlCategoryData: {
    categoryId: number;
    categoryName: string;
  };
  isEdit: boolean;
  onClose: () => void;
}

const NewPageUrlCategoryModalForm: React.FC<NewTagModalFormProps> = ({
  onCreateNewPageUrlCategory,
  PageUrlCategoryValidationSchema,
  pageUrlCategoryData,
  isEdit,
  onClose,
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    onClose();
  };
  const handleModalOpen = () => setShowModal(true);

  const formik = useFormik({
    initialValues: {
      categoryId: isEdit ? pageUrlCategoryData?.categoryId : "",
      categoryName: "",
    },
    validationSchema: PageUrlCategoryValidationSchema,
    onSubmit: (values, { resetForm }) => {
      onCreateNewPageUrlCategory(values);
      resetForm();
      handleModalClose();
    },
  });

    useEffect(() => {
      if (isEdit) {
        formik.setValues({categoryId: pageUrlCategoryData?.categoryId, categoryName: pageUrlCategoryData?.categoryName})
        handleModalOpen();
      }
    }, [isEdit]);

  return (
    <>
      <Button variant="primary" className="mb-3" onClick={handleModalOpen}>
        Add New Category
      </Button>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit? "Update Category": "Add New Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {isEdit && (
              <Form.Group className="mb-3" controlId="categoryId">
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                  readOnly
                  defaultValue={isEdit ? pageUrlCategoryData?.categoryId : ""}
                  type="number"
                  name="categoryId"
                  onChange={formik.handleChange}
                  isInvalid={
                    !!(formik.touched.categoryId && formik.errors.categoryId)
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.categoryId}
                </Form.Control.Feedback>
              </Form.Group>
            )}
            <Form.Group className="mb-3" controlId="categoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                defaultValue={isEdit ? pageUrlCategoryData?.categoryName : ""}
                type="text"
                name="categoryName"
                onChange={formik.handleChange}
                isInvalid={
                  !!(formik.touched.categoryName && formik.errors.categoryName)
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.categoryName}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => formik.handleSubmit()}>
            {isEdit? "Update": "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewPageUrlCategoryModalForm;
